import { useMemo, useRef } from 'react';
import type { RefObject } from 'react';
import useMathRender from 'core/hooks/useMathRender';

type UseTextHtmlParams = {
  isBlockFormatted: boolean;
  text: string;
};

type UseTextHtmlReturn = {
  htmlContent: string;
  rootRef: RefObject<HTMLDivElement>;
};

function useTextHtml({ isBlockFormatted, text }: UseTextHtmlParams): UseTextHtmlReturn {
  const rootRef = useRef<HTMLDivElement>(null);

  const htmlContent = useMemo<string>(() => {
    // Guard non-string input: several JS call-sites pass values that are not
    // strings (e.g. `errorMessages: string[]`). v1 tolerated this; without the
    // guard `text.replaceAll` would throw at render time.
    if (typeof text !== 'string' || !text) return '';

    return isBlockFormatted ? text : text.replaceAll('\n', '<br />');
  }, [isBlockFormatted, text]);

  useMathRender(rootRef, [htmlContent]);

  return { htmlContent, rootRef };
}

export default useTextHtml;
